/* src/components/Navbar.jsx  - Modificado 26-02-2026 */
/* ----- Navbar menu central de la Aplicación ------- */

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Button, IconButton, Typography, Divider, Box,
         Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import { Brightness4, Brightness7 } from '@mui/icons-material';

import { RiHome6Line, RiAccountCircleLine, RiVideoFill,
         RiLogoutCircleRLine } from 'react-icons/ri';

import Perfil from './pages/Perfil.jsx';
import { useAuth } from '../context/AuthContext.jsx';


const Navbar = ({ toggleSidebar = () => {}, modo, setModo }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth(); // 👈 logout centralizado
  const [openPerfilModal, setOpenPerfilModal] = useState(false);
  const appVersion = process.env.REACT_APP_VERSION;

  const [openLogoutDialog, setOpenLogoutDialog] = useState(false); // Dialogo Logout

  /* ---------------- LOGOUT ---------------- */
  const handleLogout = () => {
    sessionStorage.setItem('manualLogout', 'true'); // 🔒 Marca logout manual
    logout();
    setOpenLogoutDialog(false);
    navigate('/login', { replace: true });
  };

  /* ------------- Toggle Menu --------------- */
  const handleToggleSidebar = () => {
    if (typeof toggleSidebar === "function") {
      toggleSidebar();
    }
  };

  /* ---------------- PERFIL ---------------- */
  const handlePerfilClick = () => {
    if (!user) return;
    setOpenPerfilModal(true);
  };

  if (!user) return null;

  return (
    <AppBar
      position="fixed"
      sx={(theme) => ({
        zIndex: 1300,
        backgroundColor: theme.custom.ui.navBg,
        color: theme.palette.common.white,
        borderBottom: `1px solid ${theme.custom.ui.borderSubtle}`,
        boxShadow: 'none',
      })}
    >
      <Toolbar disableGutters sx={{ minHeight: 64, px: 2 }}>
        {/* Toggle Sidebar */}
        <IconButton
          color="inherit"
          onClick={handleToggleSidebar}
          sx={(theme) => ({
            color: theme.palette.common.white,
            textTransform: 'none',
            borderRadius: 8,
            mr: 1.5,
            '&:hover': {
              backgroundColor: theme.custom.ui.navHoverBg,
            },
          })}
        >
          <MenuIcon />
        </IconButton>

        {/* Título + usuario */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minWidth: 0,          // 🔥 CRÍTICO
            overflow: "hidden",   // 🔥 evita romper layout
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              letterSpacing: "0.02em",
            }}
          >
            Overwatch
          </Typography>

          <Typography
            variant="caption"
            sx={{
              ml: 1,
              mt: "4px",
              color: "text.secondary",
              fontSize: "0.7rem",
              userSelect: "none",
              whiteSpace: "nowrap", // 🔥 extra pro
            }}
          >
            v{appVersion}
          </Typography>

          {/* Marca */}
          <Box sx={{ color: (theme) => theme.custom.ui.brandAccent }}>
            <RiVideoFill size={22} style={{ marginLeft: 10 }} />
          </Box>

          {/* Nombre Usuario */}
          <Typography
            variant="h6"
            sx={{
              ml: 2,
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 220, // 🔥 ajustable
            }}
          >
            {user.nombre}
          </Typography>
        </Box>

        <Box
          sx={{
            ml: "auto",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {/* Inicio */}
          <Button
            color="inherit"
            component={Link}
            to="/home"
            sx={(theme) => ({
              color: theme.palette.common.white,
              textTransform: "none",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,

              "&:hover": {
                backgroundColor: theme.custom.ui.navHoverBg,
              },
            })}
          >
            <RiHome6Line style={{ fontSize: "1.5rem" }} />
            Inicio
          </Button>

          {/* Perfil */}
          <Button
            color="inherit"
            onClick={handlePerfilClick}
            sx={(theme) => ({
              color: theme.palette.common.white,
              textTransform: "none",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,

              "&:hover": {
                backgroundColor: theme.custom.ui.navHoverBg,
              },
            })}
          >
            <RiAccountCircleLine style={{ fontSize: "1.5rem" }} />
            Perfil
          </Button>

          {/* Tema */}
          <IconButton
            color="inherit"
            onClick={() => setModo(modo === "light" ? "dark" : "light")}
            sx={(theme) => ({
              color: theme.palette.common.white,
              borderRadius: 2,

              "&:hover": {
                backgroundColor: theme.custom.ui.navHoverBg,
              },
            })}
          >
            {modo === "light" ? <Brightness4 /> : <Brightness7 />}
          </IconButton>

          {/* Logout */}
          <Button
            color="inherit"
            onClick={() => setOpenLogoutDialog(true)}
            sx={(theme) => ({
              color: theme.palette.common.white,
              textTransform: "none",
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,

              "&:hover": {
                backgroundColor: theme.custom.ui.navHoverBg,
              },
            })}
          >
            <RiLogoutCircleRLine style={{ fontSize: "1.5rem" }} />
            Cerrar Sesión
          </Button>
        </Box>

        <Dialog
          open={openLogoutDialog}
          onClose={() => setOpenLogoutDialog(false)}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: (theme) => theme.custom.ui.backdropBg,
                backdropFilter: 'blur(4px)',
              },
            },

            paper: {
              sx: (theme) => ({
                backgroundColor: theme.custom.ui.modalBg,
                border: `1px solid ${theme.custom.ui.borderSubtle}`,
                color: theme.palette.text.primary,
                minWidth: 360,
                borderRadius: 8,
                boxShadow: theme.custom.ui.modalShadow,
              }),
            },
          }}
        >
          {/* ---------- Header ---------- */}
          <DialogTitle
            sx={{
              fontWeight: 600,
              pb: 1,
            }}
          >
            ¿Deseas cerrar sesión?
          </DialogTitle>

          <Divider />

          {/* ---------- Content ---------- */}
          <DialogContent sx={{ pt: 2 }}>
            <Typography
              variant="body2"
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            >
              Esta acción cerrará tu sesión actual y no puede deshacerse.
            </Typography>
          </DialogContent>

          {/* ---------- Actions ---------- */}
          <DialogActions
            sx={{
              px: 3,
              pt: 2,
              pb: 1.5,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5,
            }}
          >
            {/* Cancelar */}
            <Button
              onClick={() => setOpenLogoutDialog(false)}
              sx={(theme) => ({
                backgroundColor: theme.custom.ui.secondaryActionBg,
                color: theme.custom.ui.secondaryActionText,
                fontWeight: 500,
                borderRadius: 8,
                padding: '6px 14px',
                minHeight: 36,
                border: `1px solid ${theme.custom.ui.secondaryActionBorder}`,

                '&:hover': {
                  backgroundColor: theme.custom.ui.secondaryActionBgHover,
                  boxShadow:
                    theme.palette.mode === 'dark'
                      ? `inset 0 0 0 1px ${theme.custom.ui.secondaryActionBorderHover}`
                      : theme.custom.ui.surfaceShadow,
                },
              })}
            >
              Cancelar
            </Button>

            {/* Salir */}
            <Button
              onClick={handleLogout}
              sx={(theme) => ({
                backgroundColor: theme.custom.ui.primaryActionBg,
                color: theme.custom.ui.primaryActionText,
                fontWeight: 600,
                borderRadius: 8,
                padding: '6px 16px',
                minHeight: 36,
                boxShadow: theme.custom.ui.primaryActionShadow,

                '&:hover': {
                  backgroundColor: theme.custom.ui.primaryActionBgHover,
                  boxShadow: theme.custom.ui.primaryActionShadowHover,
                },
              })}
            >
              Salir
            </Button>
          </DialogActions>

          <Divider />

          {/* ---------- Footer / Marca ---------- */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
              py: 1.5,
              opacity: 0.75,
              color: (theme) => theme.custom.ui.brandAccent,
            }}
          >
            <RiVideoFill size={18} />
            <Typography variant="caption" color="text.secondary">
              Overwatch
            </Typography>
          </Box>
        </Dialog>

      </Toolbar>

      {/* Modal Perfil */}
      <Perfil
        open={openPerfilModal}
        onClose={() => setOpenPerfilModal(false)}
      />
    </AppBar>
  );
};

export default Navbar;
